<template>
    <div id="order-details-view">
        <div class="detail-block p-7">
            <span class="text-3xl">{{translate(orderDetails.details[0].product, 'name')}}</span>
            <div class="pt-4">
                <span class="text-1xs text-grey-text block">{{$t('myorders.date')}}</span>
                <span class="text-xl block">{{orderDetails.details[0].date | mediumDate}}</span>
            </div>
            <div class="pt-4">
                <span class="text-1xs text-grey-text block">{{$t('myorders.order')}}</span>
                <span class="text-xl block">{{orderDetails.reference}}</span>
            </div>
        </div>
        <div class="detail-block text-center py-7 mt-3" v-for="detail in orderDetails.details" :key="detail.id">
            <span class="text-1sm text-grey-text text-light font-light block">{{detail.participant_name}}</span>
            <span class="text-1xl block">{{detail.firstname}} {{detail.lastname}}</span>
            <div v-if="detail.confirmation_code">
                <qrcode-vue class="py-5" size="180" :value="detail.confirmation_code"/>
                <span class="text-xl tracking-5xl">{{detail.confirmation_code}}</span>
            </div>
        </div>
        <div class="detail-block p-7 my-3">
            <div class="font-medium text-1sm">
                <div class="detail-left">
                    <span>{{ $t("review.subtotal") }}</span>
                </div>
                <div class="detail-right">
                    <span>{{orderDetails.total_price | money}}</span>
                </div>
            </div>
            <div class="font-medium text-1sm text-grey-text">
                <div class="detail-left">
                    <span class="font-light">{{ $t("review.vat") }} {{parseInt(orderDetails.details[0].tax_percent)}}%</span>
                </div>
                <div class="detail-right">
                    <span>{{orderDetails.total_tax | money}}</span>
                </div>
            </div>
            <div class="font-medium text-1sm pt-2 pb-3">
                <div class="detail-left uppercase align-bottom">
                    <span class="align-text-bottom">{{ $t("review.total") }}</span>
                </div>
                <div class="detail-right">
                    <span class="text-2xl">{{ totalPriceFormatted.substring(0, totalPriceFormatted.indexOf(",")) }}</span>
                    <span>{{ totalPriceFormatted.substring(totalPriceFormatted.indexOf(","), totalPriceFormatted.length) }}</span>
                </div>
            </div>
            <div class="detail font-medium text-1sm py-4 border-b-1 border-grey-border" v-for="detail in orderDetails.details" :key="detail.id">
                <div class="detail-left">
                    <span>{{detail.participant_name}}</span>
                </div>
                <div class="detail-right">
                    <span>{{detail.total_price_tax | money}}</span>
                </div>
                <div v-for="extra in detail.extras" :key="extra.id">
                    <div class="detail-left">
                        <span>{{extra.product_name}}</span>
                    </div>
                    <div class="detail-right">
                        <span>{{extra.total_price_tax | money}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { translate }  from '@/helpers/translationsHelpers.js';
import QrcodeVue from 'qrcode.vue';

export default {
    name: "OrderDetails",
    computed: {
        ...mapGetters('order', ['orderDetails']),
        totalPriceFormatted: function(){
            return this.$options.filters.money(this.orderDetails.total_price_tax)
        }
    },
    components: {
        QrcodeVue,
    },
    methods: {
        translate(object, field) {
            return translate(object, field)
        }
    }
}
</script>

<style scoped>
    .detail-block {
        @apply bg-white border-b-1 border-grey-border;
    }

    .detail-left {
        @apply w-8/12 inline-block;
    }

    .detail-right {
        @apply w-4/12 inline-block text-right align-top;
    }

    [class~='detail']:last-of-type {
        @apply border-0 !important;
    }
</style>

<style>
    #order-details-view canvas {
        @apply mx-auto;
    }
</style>